import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import Select, { components, type SingleValueProps, type OptionProps } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SORTING_OPTIONS } from './constants';
import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { wideAreaSearch } from 'bundles/connect/helpers/map_helper';
import { selectMapBounds } from 'bundles/connect/components/store/selectors/criteria';
import type { Criteria, MapBounds } from 'bundles/connect/types';

type DataProps = {
  data: {
    icon: any;
    label: string;
    value: string;
  };
}

type SortingSelectProps = {
  criteria: Criteria;
  setFilterAttribute: (attribute: string, value: string, options?: any) => { type: string } | undefined;
}

const Control = (props: any) => <components.Control className="form-select as-button" {...props} />;

const CustomValue = ({ data }: DataProps) => (
  <div className="d-flex align-items-center justify-content-between w-100">
    {data.label}
    {data.icon && <FontAwesomeIcon className="me-4" icon={data.icon} />}
  </div>
);

const SingleValue = (props: SingleValueProps<any, false>) => (
  <components.SingleValue {...props}>
    <CustomValue data={props.data} />
  </components.SingleValue>
);

const Option = (props: OptionProps<any, false>) => (
  <components.Option {...props}>
    <CustomValue data={props.data} />
  </components.Option>
);

const SortingSelect = ({ criteria, setFilterAttribute }: SortingSelectProps) => {
  const mapBounds = useSelector(selectMapBounds);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const isTooWide = wideAreaSearch(mapBounds as MapBounds);
    setDisabled(isTooWide);
    if (isTooWide) {
      setFilterAttribute('sortBy', '');
    }
  }, [mapBounds]);

  return (
    <OverlayTrigger
      overlay={
        disabled ? (
          <Tooltip>Sorting enabled at a smaller map area.</Tooltip>
        ) : (
          <></>
        )
      }
      placement="bottom"
    >
      <div>
        <Select
          blurInputOnSelect
          classNamePrefix="react-select-connect"
          classNames={{
            control: ({ selectProps: { value } }) => !value.value ? '' : 'active'
          }}
          components={{
            Control,
            IndicatorsContainer: () => null,
            Option,
            SingleValue
          }}
          isDisabled={disabled}
          isSearchable
          name="sortBySelect"
          options={SORTING_OPTIONS}
          value={SORTING_OPTIONS.find(option => option.value === criteria.sortBy) || SORTING_OPTIONS[0]}
          onChange={data => setFilterAttribute('sortBy', data.value)}
        />
      </div>
    </OverlayTrigger>
  );
};

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(SortingSelect);
